<template>
  <!-- Main content -->
  <section class="content">
    <!-- GitHub hint -->
    <div class="row">
      <div class="col-xs-12"></div>
      <!-- fix for small devices only -->
      <div class="clearfix visible-sm-block"></div>
    </div>

    <!-- Main row -->
    <div class="row center-block">
      <div class="col-12">
        <md-card>
          <md-card-header>
            <img class="img-thumbnail" src="/static/img/pro1.jpg" style="width: 100px;height: 100px;"/>
            <!--                        <div class="md-title">Change Profile Details</div>-->
          </md-card-header>

          <md-card-content>
            <form class="row-rm-padding">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <div class="col-md-12">
                    <md-field>
                      <label class="lable-fileds">Email</label>
                      <md-input name="email" id="email" v-model="PForm.email" readonly/>
                    </md-field>
                  </div>
                  <div class="col-md-6">
                    <md-field :class="getValidationClassPForm('first_name')">
                      <label class="lable-fileds">Name</label>
                      <md-input name="first_name" id="first_name" v-model="PForm.first_name"/>
                      <span class="md-error" v-if="!$v.PForm.first_name.required">The First Name is required</span>
                      <span class="md-error" v-if="$v.PForm.first_name.required && this.PFormBackendValidation.first_name.isError">{{this.PFormBackendValidation.first_name.errorMsg}}</span>
                    </md-field>
                  </div>
                  <div class="col-md-6">
                    <md-field :class="getValidationClassPForm('c_password')">
                      <label class="lable-fileds">Current password</label>
                      <md-input type="password" name="c_password" id="c_password" v-model="PForm.password"/>
                      <span class="md-error" v-if="!$v.PForm.password.required">The current password is required</span>
                      <span class="md-error" v-if="$v.PForm.password.required && this.PFormBackendValidation.password.isError">{{this.PFormBackendValidation.password.errorMsg}}</span>
                    </md-field>
                  </div>
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions>
            <md-button class="btn primary-btn-my md-raised md-primary" @click="validateSubmissionPForm">Update Profile
            </md-button>
            <md-button class="md-accent" @click="resetForm">Cancel</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>
    <div class="row center-block" style="padding-top: 20px;">
      <div class="col-12">
        <md-card>
          <md-card-header>
            <div class="md-title">Change Password</div>
          </md-card-header>

          <md-card-content>
            <form class="row-rm-padding">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClassChangPForm('password')">
                    <label class="lable-fileds">Current password</label>
                    <md-input type="password" name="password" id="password" v-model="chngPForm.password"/>
                    <span class="md-error" v-if="!$v.chngPForm.password.required">The your old password is required</span>
                    <span class="md-error" v-if="$v.chngPForm.password.required && this.chngPFormBackendValidation.password.isError">{{this.chngPFormBackendValidation.password.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClassChangPForm('new_password')">
                    <label class="lable-fileds">New password</label>
                    <md-input type="password" name="new_password" id="new_password" v-model="chngPForm.new_password"/>
                    <span class="md-error" v-if="!$v.chngPForm.new_password.required">The new Password is required</span>
                    <span class="md-error" v-if="$v.chngPForm.new_password.required && this.chngPFormBackendValidation.new_password.isError">{{this.chngPFormBackendValidation.new_password.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClassChangPForm('confirm_password')">
                    <label class="lable-fileds">Confirm password</label>
                    <md-input type="password" name="confirm_password" id="confirm_password" v-model="chngPForm.confirm_password"/>
                    <span class="md-error" v-if="!$v.chngPForm.confirm_password.required">The confirm password is required</span>
                    <span class="md-error" v-if="$v.chngPForm.confirm_password.required && this.chngPFormBackendValidation.confirm_password.isError">{{this.chngPFormBackendValidation.confirm_password.errorMsg}}</span>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions>
            <md-button class="btn primary-btn-my md-raised md-primary" @click="validateSubmissionChngPForm">Change
              Password
            </md-button>
            <md-button class="md-accent" @click="resetForm">Cancel</md-button>
          </md-card-actions>
        </md-card>

      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>

<script>
  import {required} from 'vuelidate/lib/validators'
  import {validationMixin} from 'vuelidate'
  import api from '../../../api'
  import $ from 'jquery'

  export default {
    name: 'ProfileView',
    mixins: [validationMixin],
    data() {
      return {
        PForm: {
          id: null,
          // title: null,
          first_name: null,
          // last_name: null,
          // email: null,
          password: null
        },
        chngPForm: {
          id: null,
          password: null,
          new_password: null,
          confirm_password: null
        },
        PFormBackendValidation: {
          first_name: {
            isError: false,
            errorMsg: ''
          },
          password: {
            isError: false,
            errorMsg: ''
          }
        },
        chngPFormBackendValidation: {
          password: {
            isError: false,
            errorMsg: ''
          },
          new_password: {
            isError: false,
            errorMsg: ''
          },
          confirm_password: {
            isError: false,
            errorMsg: ''
          }
        }
      }
    },
    validations: {
      PForm: {
        first_name: {
          // required
        },
            // last_name: {
            //   required
            // },
        password: {
          required
        }
            // title: {
            //   required
            // }
      },
      chngPForm: {
        password: {
          // required
        },
        new_password: {
          // required
        },
        confirm_password: {
          // required
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getProfileDetails()
      })
    },
    methods: {
      getValidationClassPForm(fieldName) {
        const field = this.$v.PForm[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      getValidationClassChangPForm(fieldName) {
        const field = this.$v.chngPForm[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      getProfileDetails() {
        api.request('get', '/admin/profile')
              .then(response => {
                var ref = this
                if (response.status === 200) {
                  ref.PForm = response.data.result
                  ref.chngPForm.id = response.data.result
                } else {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'error', title: 'Something wrong'})
                }
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
      },
      validateSubmissionPForm() {
        this.$v.PForm.$touch()
        if (!this.$v.PForm.$invalid) {
          // eslint-disable-next-line no-undef
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, update my profile details!'
          }).then((result) => {
            if (result.value) {
              this.submitProfileDetails(this.$v.PForm.$model)
            }
          })
        }
      },
      validateSubmissionChngPForm() {
        this.$v.chngPForm.$touch()
        if (!this.$v.chngPForm.$invalid) {
              // eslint-disable-next-line no-undef
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, change password!'
          }).then((result) => {
            if (result.value) {
              this.changePassword(this.$v.chngPForm.$model)
            }
          })
        }
      },
      submitProfileDetails(data) {
        api.request('post', '/admin/profile', data)
              .then(response => {
                var ref = this
                if (response.status === 200) {
                  if (response.data.error) {
                    $.each(response.data.error, function(key, valueObj) {
                      if (ref.PFormBackendValidation.hasOwnProperty(key.toString())) {
                        ref.PFormBackendValidation[key.toString()].isError = true
                        ref.PFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                        $('#' + key.toString()).parent().addClass('md-invalid')
                      }
                    })
                  } else if (response.data.result.status === 'success') {
                    ref.PForm.password = ''
                    // eslint-disable-next-line no-undef
                    toast.fire({icon: 'success', title: 'Record updated successfully'})
                  } else if (response.data.result.status === 'error') {
                    ref.PForm.password = ''
                    // eslint-disable-next-line no-undef
                    toast.fire({icon: 'error', title: response.data.result.message})
                  }
                } else {
                  ref.PForm.password = ''
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'error', title: 'Something wrong'})
                }
              }).catch(error => {
                this.$store.commit('TOGGLE_LOADING')
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
                this.response = 'Server appears to be offline'
                this.toggleLoading()
              })
      },
      changePassword(data) {
        api.request('post', '/admin/changePassword', data)
              .then(response => {
                var ref = this
                if (response.status === 200) {
                  if (response.data.error) {
                    $.each(response.data.error, function(key, valueObj) {
                      if (ref.chngPFormBackendValidation.hasOwnProperty(key.toString())) {
                        ref.chngPFormBackendValidation[key.toString()].isError = true
                        ref.chngPFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                        $('#' + key.toString()).parent().addClass('md-invalid')
                      }
                    })
                    ref.chngPForm.password = ''
                  } else if (response.data.result.status === 'success') {
                    ref.chngPForm.password = ''
                    ref.chngPForm.new_password = ''
                    ref.chngPForm.confirm_password = ''
                    // eslint-disable-next-line no-undef
                    toast.fire({icon: 'success', title: 'Record updated successfully'})
                  } else if (response.data.result.status === 'error') {
                    ref.chngPForm.password = ''
                    // eslint-disable-next-line no-undef
                    toast.fire({icon: 'error', title: response.data.result.message})
                  }
                } else {
                  ref.chngPForm.password = ''
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'error', title: 'Something wrong'})
                }
              }).catch(error => {
                this.$store.commit('TOGGLE_LOADING')
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
                this.response = 'Server appears to be offline'
                this.toggleLoading()
              })
      },
      resetForm() {
        this.$router.go()
      }
    }
  }
</script>

<style>
  /* layout.css Style */
  .upload-drop-zone {
    height: 100px;
    border-width: 2px;
    margin-bottom: 20px;
  }

  /* skin.css Style*/
  .upload-drop-zone {
    color: #ccc;
    border-style: dashed;
    border-color: #ccc;
    line-height: 100px;
    text-align: center
  }

  .upload-drop-zone.drop {
    color: #222;
    border-color: #222;
  }


  div.fileinputs {
    position: relative;
  }

  div.fakefile {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
  }

  input.file {
    position: relative;
    text-align: right;
    -moz-opacity: 0;
    filter: alpha(opacity:0);
    opacity: 0;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// profileView.vue?d70c220a